export function CursorClickIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12.4999 12.4998L10.8332 16.6665L7.49986 7.4998L16.6665 10.8331L12.4999 12.4998ZM12.4999 12.4998L16.6665 16.6665M5.99005 1.86523L6.6371 4.28005M4.28005 6.63706L1.86523 5.99002M11.6246 3.37504L9.85685 5.14281M5.14288 9.85677L3.37512 11.6245" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}
